module.exports = __webpack_public_path__ + "static/img/6.0a38cae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-de/6.jpg
// module id = Jzef
// module chunks = 1